<script>
    import Header from "./lib/interface/Header.svelte";
    import Footer from "./lib/interface/Footer.svelte";
    import Survey from "./lib/Survey.svelte";
    import Thanks from "./lib/interface/Thanks.svelte";

    import user_language_options from "./lib/interface/user_language_options.json";
    import { user_language } from "./lib/stores.js";

    // if not on prod, enable debugging tools
    let enable_debug = window.location.hostname === "reflection.dora.dev" ? false : true;

    let appStage = "survey";

    // check for usertags passed through URL
    let params = new URLSearchParams(window.location.search);
    if (params.get("stage")) {
        if (params.get("stage") === "thanks") {
            appStage = "thanks";
        }
    }

</script>

<Header bind:user_language={$user_language} {user_language_options} />

<main>
    <aside id="sidebar"></aside> <!-- used to display debug info -->
    <div id="contents">
        {#if appStage === "survey"}
            <Survey bind:user_language={$user_language} {enable_debug}/>
        {:else if appStage === "thanks"}
            <Thanks user_language={$user_language} />
        {:else}
            ERROR: unknown `appStage`: {appStage}
        {/if}
    </div>
</main>

<Footer user_language={$user_language} />

<style lang="scss">
    main {
        margin: 0 auto;
        display: flex;

        #contents {
            max-width: 1200px;
            flex-grow:1;
        }

        aside {
            flex-shrink:1;
            white-space: pre;
            font-family: 'Courier New', Courier, monospace;
            font-size:14px;
        }

    }
</style>
